module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/demos/inner-pages/about-company-deca19b762ad29c541ec7c5499bbb279.png";